import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        link: '#FF6B00',
        primary: '#FCA66E',
        spinnerColor: '#111111'
      },
      dark: {
        link: '#9B8AD8',
        primary: '#5F4CBA',
        spinnerColor: '#FFFFFF'
      }
    }
  },
  icons: {
    iconfont: 'md'
  }
})
